var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3208",
    "data-name": "Group 3208",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.397,
    height: 35.516,
    viewBox: "0 0 44.397 35.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3205",
    "data-name": "Group 3205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 42,
    height: 33,
    rx: 3,
    transform: "translate(1.126 1.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "image-gallery",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3202",
    "data-name": "Group 3202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M43.956,37.516H8.44A4.444,4.444,0,0,1,4,33.077V6.44A4.444,4.444,0,0,1,8.44,2H43.956A4.444,4.444,0,0,1,48.4,6.44V33.077A4.444,4.444,0,0,1,43.956,37.516ZM8.44,4.22A2.223,2.223,0,0,0,6.22,6.44V33.077A2.223,2.223,0,0,0,8.44,35.3H43.956a2.223,2.223,0,0,0,2.22-2.22V6.44a2.223,2.223,0,0,0-2.22-2.22Z",
    transform: "translate(-4 -2)",
    fill: "#2c2c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3203",
    "data-name": "Group 3203",
    transform: "translate(6.659 6.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M11.44,13.879a4.44,4.44,0,1,1,4.44-4.44A4.444,4.444,0,0,1,11.44,13.879Zm0-6.659a2.22,2.22,0,1,0,2.22,2.22A2.223,2.223,0,0,0,11.44,7.22Z",
    transform: "translate(-7 -5)",
    fill: "#2c2c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3204",
    "data-name": "Group 3204",
    transform: "translate(0.155 12.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M5.18,28.371a1.109,1.109,0,0,1-.786-1.893L14.878,15.994a3.412,3.412,0,0,1,4.708,0l3.121,3.121L31.347,8.749a3.335,3.335,0,0,1,2.535-1.2h.024a3.328,3.328,0,0,1,2.528,1.161L48.044,22.256A1.11,1.11,0,0,1,46.359,23.7L34.75,10.156a1.1,1.1,0,0,0-.844-.386,1.178,1.178,0,0,0-.852.4l-9.418,11.3a1.106,1.106,0,0,1-.8.4A1.068,1.068,0,0,1,22,21.543l-3.98-3.98a1.14,1.14,0,0,0-1.569,0L5.964,28.047a1.106,1.106,0,0,1-.784.324Z",
    transform: "translate(-4.07 -7.55)",
    fill: "#2c2c2c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/img-icon.4378bb79.svg";
export { ForwardRef as ReactComponent };